<template>
	<v-card-text style="position: relative; padding-top: 0" class="ma-0">
        <v-speed-dial
            v-show="!showDial"
            v-model="fab"
            :fixed="actionPositionFixed"
            :bottom="actionPositionFixed"
            :absolute="actionPositionAbsolute"
            :left="positionLeft"
            :right="positionRight"
            :direction="direction"
            :style="speedDialStyle"
            transition="scale-transition">
            <template v-slot:activator>
                <v-btn
                    color="primary"
                    dark
                    fab
                    v-model="fab">
                    <v-icon v-if="fab">close</v-icon>
                    <v-icon v-else>{{ actionIcon }}</v-icon>
                </v-btn>      
            </template>
            
            <template v-for="{ button, b } in visibleButtons">
                <template v-if="$eventBusUtility.showButton(button)">
                    <!-- Pulsante Add -->
                    <v-tooltip top v-if="button.type === 'add'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                v-on="{ ...tooltip }"
                                fab
                                dark
                                small
                                :color="button.color || 'indigo'"
                                :depressed="canAdd"
                                :disabled="canAdd"
                                @click.native.stop="openCreate">
                                <v-icon>{{ button.icon || 'add' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ button.tooltip || 'Nuovo' }}</span>
                    </v-tooltip>
                    
                    <!-- Pulsante Delete -->
                    <v-tooltip top v-else-if="button.type === 'delete'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                fab
                                dark
                                small
                                :color="button.color || 'red'"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => confirmDelete = true)">
                                <v-icon>{{ button.icon || 'delete' }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button, 'Elimina') }}</span>     
                    </v-tooltip>
                    
                    <!-- Pulsante CSV -->
                    <v-tooltip top v-else-if="button.type === 'csv'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                v-on="{ ...tooltip }"
                                fab
                                dark
                                small
                                :color="button.color || 'green'"
                                :depressed="disabled"
                                :disabled="disabled"
                                @click.native.stop="$emit('export-csv', button)">
                                <v-icon>{{ button.icon || 'play_for_work' }}</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ button.tooltip || 'Esporta CSV' }}</span>   
                    </v-tooltip>

                    <!-- Pulsante ZIP -->
                    <v-tooltip top v-else-if="button.type === 'zip'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                fab
                                dark
                                small
                                :color="button.color ? button.color : 'orange'"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => button.dialog ? openZipDialog(b) : $eventBusUtility.generateZip($store, typeof button.url !== 'undefined' ? button.url :  '/download-zip/'+modelDef, { selected: selectedIds }))">
                                <v-icon>{{ button.icon ? button.icon : 'mdi-zip-box'}}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button, 'Scarica ZIP') }}</span>
                    </v-tooltip>
                    
                    <!-- Pulsante Route -->
                    <v-tooltip top v-else-if="button.type === 'route'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                fab
                                dark
                                small
                                :color="button.color"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => $router.push({name: button.route.name, params: { selected: actionSelected, ...button.params, ...infoData.buttonParams }}))">
                                <v-icon>{{ button.icon }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button) }}</span>
                    </v-tooltip>
                    
                    <!-- Multiple Edit -->
                    <v-tooltip top v-else-if="button.type === 'multiple_edit'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                fab
                                dark
                                small
                                :color="button.color ? button.color : 'pink lighten-1'"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, multipleEdit)">
                                <v-icon>{{ button.icon ? button.icon : 'edit' }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button, 'Modifica multipla') }}</span>
                    </v-tooltip>
                    
                    <!-- Component -->
                    <v-tooltip top v-else-if="button.type === 'component'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                :fab="button.icon ? true : false"
                                dark
                                small
                                :color="button.color"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => toggleComponentDialog(b, true))">
                                <v-icon>{{ button.icon }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button) }}</span>
                    </v-tooltip>
                    
                    <!-- Confirm -->
                    <v-tooltip top v-else-if="button.type === 'confirm'" :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                :fab="button.icon ? true : false"
                                dark
                                small
                                :color="button.color"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => openConfirm(b, true))">
                                <v-icon>{{ button.icon }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button) }}</span>
                    </v-tooltip>
                    
                    <!-- Altri tipi di pulsanti -->
                    <v-tooltip v-else top :key="b">
                        <template v-slot:activator="{ on: tooltip }">
                            <span v-on="tooltip" class="d-inline-block">
                            <v-btn
                                :data-test="'bulk-' + (button.key || button.type)"
                                fab
                                dark
                                small
                                :color="button.color"
                                v-bind="selectionButtonState(button)"
                                @click.native.stop="withSelection(button, () => callFunction(button.function))">
                                <v-icon>{{ button.icon }}</v-icon>
                            </v-btn>
                            </span>
                        </template>
                        <span>{{ tooltipText(button) }}</span>
                    </v-tooltip>
                </template>
            </template>
        </v-speed-dial>

        <confirm-dialog
			:confirmModel="confirmDelete"
			:mainTitle="allSelected ? `Eliminare tutti i ${selectedIds.length.toLocaleString('it-IT')} elementi selezionati?` : 'Eliminare gli elementi selezionati?'"
			secondTitle="Gli elementi selezionati verranno eliminati solamente se indipendenti e non collegati a nessun altra entità. Una volta eliminati non sarà possibile ripristinarli"
			@update:confirmModel="confirmDelete = false"
			:atConfirm="deleteModels"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>

        <confirm-dialog v-if="currentConfirmButton"
			:confirmModel="confirmAction"
			:mainTitle="currentConfirmButton.mainTitle"
			:secondTitle="currentConfirmButton.secondTitle"
			@update:confirmModel="confirmAction = false"
			:atConfirm="executeAction"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>

        <v-dialog v-model="zipDialog" max-width="500px">
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Opzioni Download ZIP</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-checkbox
                        v-model="zipMergeOption"
                        label="Unisci i PDF in un unico file"
                        hint="Se selezionato, tutti i PDF verranno uniti in un singolo documento"
                        persistent-hint
                    ></v-checkbox>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="info" text @click="zipDialog = false">
                        Annulla
                    </v-btn>
                    <v-btn color="primary" text @click="executeZipDownload">
                        Scarica
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>        
        
        <template v-for="(button, b) in buttonsset">
            <component
                v-if="button.component"
                :is="button.component"
                :open.sync="dialogComponent[b]"
                :key="'dialog_'+b"
                :selected="actionSelected"
                :selected-ids="selectedIds"
                v-bind="serverSelectAllProps(button)"
                :model-def="modelDef"
                :params="button.params"
                :button="button"
                @close="toggleComponentDialog(b, false)">
            </component>
        </template>
	</v-card-text>
</template>

<script>
	import Vue from 'vue'
	import { selectionLimit, usesServerSelectAll } from '@/services/bulkSelection'
	import GenerateDdt from '@/components/common/GenerateDdt'
	import ParseDocDialog from '@/components/common/ParseDocDialog'
	import InventoryDialog from '@/components/common/InventoryDialog'
	import UploadFileDialog from '@/components/common/UploadFileDialog'
	import PdfPreviewDialog from '@/components/common/PdfPreviewDialog'
	import SendMultipleMails from '@/components/common/SendMultipleMails'
	import ConvertDocumentDialog from '@/components/common/ConvertDocumentDialog'
	import CallqueueDialog from '@/components/modules/callcenter/CallqueueDialog'
    import MaillistDialog from '@/components/modules/mailmarketing/MaillistDialog'
	import GeneratePayments from '@/components/modules/deadlines/GeneratePayments'
	import SettleDeadlines from '@/components/modules/deadlines/SettleDeadlines'
	import ImportSettlements from '@/components/modules/deadlines/ImportSettlements'
	import WhatsAppListDialog from '@/components/modules/whatsapp/WhatsAppListDialog'
	import GenerateTroubleDialog from '@/components/modules/tickets/GenerateTroubleDialog'
	import EdocumentSenderButton from '@/components/modules/invoices/EdocumentSenderButton'
	import ContainersGenerateDdt from '@/components/modules/agribios/ContainersGenerateDdt'
	import GenerateBarcodeDialog from '@/components/modules/products/GenerateBarcodeDialog'
	import MergeTicketsDialog from '@/components/modules/helpdesk/MergeTicketsDialog'
	import ImportPurchaseordersDialog from '@/components/modules/orders/ImportPurchaseordersDialog'
	import ImportEdocumentsDialog from '@/components/modules/invoices/edocuments/ImportEdocumentsDialog'

	export default {
        name: 'buttons-generator',
        components: {
            GenerateDdt,
            MaillistDialog,
            ParseDocDialog,
            CallqueueDialog,
            InventoryDialog,
            PdfPreviewDialog,
            UploadFileDialog,
            GeneratePayments,
            SettleDeadlines,
            ImportSettlements,
            SendMultipleMails,
            WhatsAppListDialog,
            EdocumentSenderButton,
            ContainersGenerateDdt,
            GenerateTroubleDialog,
            ConvertDocumentDialog,
            GenerateBarcodeDialog,
            MergeTicketsDialog,
            ImportPurchaseordersDialog,
            ImportEdocumentsDialog,
        },
		props: {
            title: String,
            infoData: Object,
            actionIcon: String,
            defaultInput: Object,
            disabled: Boolean,
            showDial: Boolean,
            speedDialOptions: Object,
            selected: Array,
            // selezione "tutti" di Crud: righe fuori pagina incluse (services/bulkSelection.js)
            allSelected: {
                type: Boolean,
                default: false
            },
            // elementi selezionati: in "tutti" il totale della lista
            countSelected: Number,
            // filtri della tabella per i dialog che risolvono "tutti" sul backend
            listFilters: Object,
            // () => Promise<righe>: carica in Crud tutte le righe della lista, per le altre azioni
            resolveAllSelected: Function,
            // righe di "tutti" già caricate da resolveAllSelected
            allSelectedRows: Array,
            actionPosition: {
                default: 'fixed',
                type: String,
            },
			positionRight: {
				type: Boolean,
				default: true
			},
			positionLeft: {
				type: Boolean,
				default: false
            },
			direction: {
				type: String,
				default: 'left'
            },
		},
		data() {
            return {
                val: true,
                fab: false,
                type: '',
                modelDef: this.infoData.modelDef,
                maxUsers: this.infoData.max_users,
                usersNumber: this.infoData.users_number,
                confirmDelete: false,
                dialogComponent: [],
                confirmAction: false,
                currentConfirmButton: null,
                zipDialog: false,
                zipMergeOption: false,
                currentZipButton: null,
                // pulsante che sta caricando le righe di "tutti" (rotellina sul pulsante)
                resolving: null,
			}
        },
        

		computed: {

            // Computed e non copia in data(): Crud parte dalla -info in cache e poi
            // applica quella fresca, e i pulsanti devono seguirla (permessi per ruolo)
            buttonsset() {
                return this.infoData.buttonDefs || []
            },

        	canAdd() {
				if(this.modelDef !== 'users') {
					return false
				} else {
					if(this.usersNumber < this.maxUsers) {
						return false
					}
				}
				return true
            },

            // La selezione su cui girano le azioni: in "tutti" le righe dell'intera lista
            actionSelected() {
                return this.allSelected && this.allSelectedRows ? this.allSelectedRows : this.selected
            },

            selectedIds() {
                return this.actionSelected.map((element) => {
                    return element.id
                })
            },

            // Senza righe selezionate i pulsanti legati alla selezione vengono
            // nascosti invece che mostrati disabilitati, cosi' i sempre-attivi
            // restano compattati a destra. L'indice originale (b) va preservato:
            // dialogComponent, openConfirm e openZipDialog puntano a buttonsset.
            visibleButtons() {
                return this.buttonsset
                    .map((button, b) => ({ button, b }))
                    .filter(({ button }) => {
                        if(!this.disabled || button.type === 'add') {
                            return true
                        }
                        // component/confirm con disabled proprio nel buttonDef
                        // non dipendono dalla selezione
                        return (button.type === 'component' || button.type === 'confirm')
                            && typeof button.disabled !== 'undefined'
                    })
            },

            actionPositionAbsolute() {
                return this.actionPosition === 'absolute'
            },

            actionPositionFixed() {
                return this.actionPosition === 'fixed'
            },

            speedDialStyle() {
                // Il pulsante e' fixed, quindi il padding che Vuetify mette su v-main per
                // la sidebar fissata non lo sposta: lo spostiamo noi della stessa misura.
                // `application.right` e' 0 quando nessun drawer destro e' registrato,
                // quindi si azzera da solo appena la sidebar viene smontata o sbloccata.
                const reservedRight = this.$vuetify.application.right

                if (!reservedRight || !this.actionPositionFixed) {
                    return {}
                }

                return {
                    right: `${reservedRight + 20}px` // Add 20px padding from drawer edge
                }
            },

        },

        methods: {
            // In "tutti" un'azione legata alla selezione oltre il suo limite resta visibile ma spenta
            overLimit(button) {
                if(!this.allSelected || !this.selectionBound(button)) {
                    return false
                }
                const limit = selectionLimit(button, this.serverSelectAll(button))
                return limit !== null && this.countSelected > limit
            },

            tooltipText(button, fallback) {
                if(this.overLimit(button)) {
                    return `Troppi elementi (max ${selectionLimit(button, false).toLocaleString('it-IT')}): restringi i filtri`
                }
                return button.tooltip || fallback
            },

            // Pulsanti legati alla selezione: spenti senza selezione o oltre il limite di "tutti",
            // rotellina mentre si caricano le righe; component e confirm possono avere un disabled proprio
            selectionButtonState(button) {
                const off = this.hasOwnDisabled(button) ? button.disabled : (this.disabled || this.overLimit(button))
                return {
                    disabled: off,
                    depressed: off,
                    loading: this.resolving === button,
                    class: { 'over-limit': this.overLimit(button) },
                }
            },

            // component e confirm possono dichiarare un disabled fisso, che vince sulla selezione
            hasOwnDisabled(button) {
                return (button.type === 'component' || button.type === 'confirm') && typeof button.disabled !== 'undefined'
            },

            // add, csv e i pulsanti con disabled proprio non usano la selezione
            selectionBound(button) {
                return button.type !== 'add' && button.type !== 'csv' && !this.hasOwnDisabled(button)
            },

            /**
             * Input:  buttonDef, action da eseguire
             * Fa:     in "tutti" carica prima le righe dell'intera lista (Crud), così l'azione
             *         riceve la selezione completa come se fosse stata spuntata a mano;
             *         i dialog con select_all lato backend partono subito
             */
            withSelection(button, action) {
                if(!this.allSelected || !this.selectionBound(button) || this.serverSelectAll(button)) {
                    return action()
                }
                if(this.resolving) {
                    return
                }
                this.resolving = button
                this.resolveAllSelected().then(rows => {
                    this.resolving = null
                    // l'azione parte quando la prop allSelectedRows porta le righe appena caricate
                    if(rows) {
                        this.$nextTick(action)
                    }
                })
            },

            // select_all sul backend: solo i dialog che lo supportano, e solo se Crud passa i filtri
            // (con la ricerca smart no: la lista viene da Meilisearch e il backend non la sa rifare)
            serverSelectAll(button) {
                return usesServerSelectAll(button) && !!this.listFilters
            },

            serverSelectAllProps(button) {
                if(!this.serverSelectAll(button)) {
                    return {}
                }
                return {
                    allSelected: this.allSelected,
                    allCount: this.countSelected,
                    listFilters: this.listFilters,
                }
            },

            toggleComponentDialog(index, value) {
                Vue.set(this.dialogComponent, index, value)
            },

            openConfirm(index, value) {
                this.confirmAction = value
                this.currentConfirmButton = this.buttonsset[index]
            },

            openZipDialog(index) {
                this.zipDialog = true
                this.currentZipButton = this.buttonsset[index]
                this.zipMergeOption = false
            },

            executeZipDownload() {
                const params = { 
                    selected: this.selectedIds,
                    merge_pdfs: this.zipMergeOption
                }
                this.$eventBusUtility.generateZip(
                    this.$store, 
                    typeof this.currentZipButton.url !== 'undefined' ? this.currentZipButton.url : '/download-zip/'+this.modelDef, 
                    params
                )
                this.zipDialog = false
                this.currentZipButton = null
            },

            callFunction(name) {
                this[name]()
            },

            openCreate() {
                this.$eventBusUtility.$emit('openCreate_'+this.modelDef)
            },

            multipleEdit() {
                this.$eventBusUtility.$emit('multipleEdit_'+this.modelDef, {'field_filters':{'multiple_edit': true}})
            },

            executeAction() {
                let ids = this.selectedIds

                this.axios.post('/' + this.currentConfirmButton.url, {ids: ids}).then(response => {
                    // get body data
                    let data = response.data
                    this.$eventBusUtility.$emit('refreshTable_'+ this.modelDef)
                    let snackmessage = ''
                    let snackcolor = ''
                    if(data.status == 'message' || data.message) {
                        snackmessage = data.message
                        snackcolor = data.status
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                    this.currentConfirmButton = null

                }, response => {
                    // error callback
                    this.confirmAction = false
                    this.currentConfirmButton = null
                })
            },
                
            deleteModels() {
                let ids = this.selectedIds

                this.axios.post(this.modelDef + '/delete', {ids: ids}).then(response => {
                    // get body data
                    let data = response.data
                    this.$eventBusUtility.$emit('refreshTable_'+ this.modelDef)
                    this.confirmDelete = false
                    let snackmessage = ''
                    let snackcolor = ''
                    if(data.status == 'message' || data.message) {
                        snackmessage = data.message
                        snackcolor = 'warning'
                    } else{
                        snackmessage = 'Elementi eliminati con successo.'
                        snackcolor = 'success'
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

                    this.$eventBusUtility.$emit('documentsDeleted', {
                        modelDef: this.modelDef,
                        ids: ids
                    })

                    // Refresh archive notifications badge when archives are deleted
                    if(this.modelDef === 'archives') {
                        this.$eventBusUtility.$emit('updateNotifications')
                    }

                }, response => {
                    // error callback
                    this.confirmDelete = false
                });
            },            
        },
	}
</script>

<style scoped>
/* Oltre il limite della selezione "tutti": spento ma leggibile, il disabled di Vuetify su fab dark è quasi trasparente */
.v-btn.over-limit.v-btn--disabled {
    background-color: #9e9e9e !important;
}
.v-btn.over-limit .v-icon {
    color: #fff !important;
}
</style>
